import '@babel/polyfill';
import '../../scss/main.scss';

// bootstrap
import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';

import React from 'react';
import ReactDOM from 'react-dom';
import Navbar from './Navbar.jsx';

import './auth';
import './fontSizeOption';
import './cookiePolicy';
import './annModal';
import './tryNow';
import './shares';
import './announcements';

// Mount React Navbar
const navbarRoot = document.getElementById('navbar');
if (navbarRoot) {
  ReactDOM.render(<Navbar redirect="/register" />, navbarRoot);
}
